const SITE_PALETTE = [
  '#00B6C3',
  '#8A9DE8',
  '#F26969',
  '#50D1ED',
  '#FA8D8D',
  '#54C37C',
  '#6262EB',
  '#F7B13C',
  '#8C65D9',
  '#B3D767',
  '#5776CA',
  '#CA9D51',
  '#959AA3',
  '#E17BF1',
  '#5060A0',
];

// siteId % PALETTE_LEN(=15)의 나머지가 다르면 항상 다른 색이 나오도록
// 15와 서로소인 값(7)을 곱하는 선형 합동 순열을 사용 (mod 15에서 전단사 보장)
const PERM_MULTIPLIER = 7;
const PERM_OFFSET = 4;

function hash(n: number): number {
  const len = SITE_PALETTE.length;
  const r = ((n % len) + len) % len;
  return r * PERM_MULTIPLIER + PERM_OFFSET;
}

export function getSiteColor(siteId: number): string {
  return SITE_PALETTE[hash(siteId) % SITE_PALETTE.length];
}
